import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-in-details-comments',
  templateUrl: './in-details-comments.component.html',
  styleUrls: ['./in-details-comments.component.scss']
})
export class InDetailsCommentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
